export default __webpack_public_path__ + "static/media/rugFreeLogo.20362403.svg";